import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Divider = styled(Box)(() => ({
  height: 1,
  background: "#747474",
  width: "100%",
}));
